import { memo, useCallback } from "react";
import { AnimatePresence } from "framer-motion";
import { useCoreApp } from "@/contexts/CoreAppContext";
import FilePreview from "@/components/file/Preview";
import { FileCarousel } from "@/components/file/Carousel/FileCarousel";
import { BoundingBoxStrategyImpl } from "@utils/annotationStrategies/BoundingBox";
import { FilePreviewProvider } from "@/contexts/FilePreviewProvider";
import { useTestWithMoreFiles } from "@/useTestWithMoreFiles";
import { useCurrentMedia } from "@/store";

export const ReviewVisualAreaContent = memo(() => {
    const { showLabels } = useCoreApp();
    const currentMedia = useCurrentMedia();
    const { testWithMoreFiles } = useTestWithMoreFiles();

    const onAddMediaItems = useCallback(
        async (files: File[], onFinally?: () => void) => {
            await testWithMoreFiles(files);

            onFinally?.();
        },
        [testWithMoreFiles]
    );

    return (
        <AnimatePresence mode="wait">
            <div className="visualArea relative">
                <div className="flex min-h-0 flex-1">
                    <FilePreviewProvider>
                        <FileCarousel onAddMediaItems={onAddMediaItems}>
                            <FilePreview
                                key={`file-${currentMedia?.file.id}`}
                                forceHideLabels={!showLabels}
                                strategy={BoundingBoxStrategyImpl}
                                includeWatermark={true}
                                watermarkQrUrl="https://rapid.roboflow.com"
                            />
                        </FileCarousel>
                    </FilePreviewProvider>
                </div>
            </div>
        </AnimatePresence>
    );
});

ReviewVisualAreaContent.displayName = "ReviewVisualAreaContent";
